'use client'

import * as React from 'react'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { useIsLoggedInQuery } from 'auth/hooks'
import { usePaymentsDialog } from 'payments/components/payments-dialog-wrapper-context'
import { useHasAllAccessQuery } from '@repo/cf-user/hooks/use-user-data'
import { addOrReplaceLanguageInUrl } from 'cf-i18n/helpers'
import { useLocale } from 'next-intl'
import type { Language } from 'codegen/types'
import {
  PAYMENT_ENTRY_POINTS,
  savePaymentModalEntryPoint,
} from 'payments/payments-dialog/analytics'

const REDIRECT_TO_CART_PAGE_QUERY_PARAM = 'getallaccess'

export function Redirects() {
  const { data: isLoggedIn, isPending } = useIsLoggedInQuery()
  const { open } = usePaymentsDialog()
  const { data: userHasAllAccess } = useHasAllAccessQuery()
  const locale = useLocale() as Language

  React.useEffect(() => {
    if (window !== undefined && !isPending) {
      const url = new URL(window.location.href)
      const params = new URLSearchParams(window.location.search)
      const hasGetAllAccessQueryParam = url.searchParams.has(REDIRECT_TO_CART_PAGE_QUERY_PARAM)

      //User is logged out redirect to cart page
      if (hasGetAllAccessQueryParam && !isLoggedIn) {
        savePaymentModalEntryPoint(PAYMENT_ENTRY_POINTS.HOMEPAGE_REDIRECT)
        window.location.href = `${url.origin}${addOrReplaceLanguageInUrl(AppRoutes.B_FREE_TRIAL, locale)}${url.search}`
        return
      }

      //If user is logged in and does not have all access, open the payments dialog
      if (hasGetAllAccessQueryParam && !userHasAllAccess) {
        savePaymentModalEntryPoint(PAYMENT_ENTRY_POINTS.HOMEPAGE_REDIRECT)
        open()
      }

      //Migrated logic from WP to remove query params after reading them:
      // https://github.com/creativefabrica/creativefabrica/blob/3e3dff78125b8bffeea14abc8dd734506753178c/wp-content/themes/creativefabricanew/cf-templates/general/footer/scripts.php#L337
      params.delete(REDIRECT_TO_CART_PAGE_QUERY_PARAM)
      params.delete('promo')
      params.delete('plan')

      const newParams = params.toString()

      //Cleanup URL parameters after reading them
      window.history.replaceState(
        {},
        '',
        `${
          newParams.length === 0
            ? window.location.pathname
            : `${window.location.pathname}?${newParams}`
        }`,
      )
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, userHasAllAccess, isPending])

  return null
}
